const findAsset = (list: any, assetId: number) => {
  return list.levels.find((level: any) => {
    return level._id === assetId;
  });
};

export default findAsset;
